import { modelHospitalReviewsAPI } from "models/hospital/reviews.api.models";
import { GetData } from "Utils/ApiCall";

export const getHospitalReviews = async ({clinicId}) =>
  modelHospitalReviewsAPI(
    await GetData(`${process.env.REACT_APP_BASE_URL}/api/common/clinic/${clinicId}/reviews/patient`)
  );